import CauseList from "./CauseList";

import { MoveLeft, Plus } from "lucide-react";

import { useAppState } from "contexts/UserContext";
import { useCause } from "contexts/CauseContext";
import { useTeam } from "contexts/TeamContext";
import { useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useMoodsTranslator } from "../../settings/components/useMoodsTranslator";
import { FeelingCause } from "types/feeling-cause";

const CausesOverviewPage = () => {
  const { activeCauseTypes, defaultCauseTypes, setActiveCauseTypes } =
    useCause();
  const { activeTeamCauseTypes, setActiveTeamCauseTypes, organizationId } =
    useTeam();
  const { t } = useTranslation();
  const moodsTranslator = useMoodsTranslator();
  const navigate = useNavigate();
  const { state } = useLocation();
  const type = state?.type;
  const [personalC, setPersonalC] = useState<FeelingCause[]>([]);
  const [teamC, setTeamC] = useState<FeelingCause[]>([]);

  useEffect(() => {
    const merged = new Map();
    (defaultCauseTypes || []).forEach((cause: FeelingCause) =>
      merged.set(cause.id, cause)
    );
    (activeCauseTypes || []).forEach((cause: FeelingCause) =>
      merged.set(cause.id, cause)
    );
    setPersonalC(Array.from(merged.values()));
    console.log("test -> " + Array.from(merged.values()));
    console.log("test -> " + JSON.stringify(Array.from(merged.values())));
    setTeamC(activeTeamCauseTypes);
  }, [activeTeamCauseTypes, activeCauseTypes, defaultCauseTypes, type]);

  return (
    <div className="root">
      <div className="settings-element-header">
        <MoveLeft
          onClick={() => navigate("/app/settings")}
          style={{ marginLeft: "5px", marginRight: "5px" }}
        />
        <p className={`settings-element-title page-title`}>
          Causes of feelings
        </p>

        <div></div>
        <Plus
          className="w-4 h-4 text-red-500"
          style={{ marginLeft: "5px", marginRight: "5px" }}
          onClick={() =>
            navigate("/app/add", {
              state: {
                fromTeamCausesSettings: true,
                type: type,
              },
            })
          }
        />
      </div>

      <div>
        <span className="secondary-title">Personal</span>
        <CauseList
          moodsTranslator={moodsTranslator}
          causeTypes={personalC}
          organizationId={organizationId}
          t={t}
          type={type}
          setActiveCauseTypes={setActiveCauseTypes}
          setActiveTeamCauseTypes={setActiveTeamCauseTypes}
        />
        {organizationId && (
          <>
            <span className="secondary-title">Team</span>
            <CauseList
              moodsTranslator={moodsTranslator}
              causeTypes={teamC}
              organizationId={organizationId}
              t={t}
              type={type}
              setActiveCauseTypes={setActiveCauseTypes}
              setActiveTeamCauseTypes={setActiveTeamCauseTypes}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default CausesOverviewPage;
